import React from 'react'

import styles from './styles.module.css'

const TooltipIcon = ({ iconStyles }) => (
  <svg className={`${styles.tooltipIcon} ${iconStyles}`}>
    <use xlinkHref='/icons.svg#icon-question-circle-o' />
  </svg>
)

const Tooltip = ({
  content = '',
  wrapperStyles = '',
  triggerStyles = '',
  iconStyles = '',
  position = 'auto',
  children
}) => (
  <div className={`${styles.wrapper} ${wrapperStyles}`}>
    <div role='button' tabIndex={0} className={styles.container} data-position={position}>
      <span className={styles.trigger}>
        <Choose>
          <When condition={children}>{children}</When>
          <Otherwise>
            <TooltipIcon iconStyles={iconStyles} />
          </Otherwise>
        </Choose>
      </span>

      <span className={styles.content}>{content}</span>
    </div>

    <span className={styles.closeButton}></span>
  </div>
)

export default Tooltip
